import * as HANDLERS from '@/helpers/types/handlers';
import store from '@/store';

const devComponentMixin = {
  data: () => ({
    loremIpsum: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    emailsDev: [
      'anderson.lima@i4pro.com.br',
      'barbara.rosal@i4pro.com.br',
      'lucas.souza@i4pro.com.br',
      'clayton.ribeiro@i4pro.com.br',
      'iorgen.silva@i4pro.com.br',
      'rafael.vidal@i4pro.com.br',
      'raphael@i4pro.com.br'
    ]
  }),

  computed: {
    getSelectedDEV() {
      let config = store.getters['authentication/getConfig'];
      let getSelected = store.getters['dev/getSelected'];
      let getCurrentMode = store.getters['dev/getCurrentMode'];

      if (this.formOptions && this.formOptions.mode !== getCurrentMode) return false;

      if (config.DEV_MODULE && getSelected.model) return getSelected.model === this.schema.model;

      return false;
    },

    getSelectedTabDEV() {
      let config = store.getters['authentication/getConfig'];

      if (config.DEV_MODULE) return store.getters['dev/getSelectedTab'];

      return false;
    },

    getSelectedStepDEV() {
      let config = store.getters['authentication/getConfig'];

      if (config.DEV_MODULE) return store.getters['dev/getSelectedStep'];

      return false;
    },

    selectedPortal() {
      return this.$store.getters['dev/getSelectedPortal'];
    },

    selectedEnvironment() {
      return this.$store.getters['dev/getSelectedEnvironment'];
    }
  },

  methods: {
    selectComponentDEV(e, param, index = null) {
      if (!store.getters['authentication/getConfig'].DEV_MODULE) return;
      e.preventDefault();

      if (this.formOptions && this.formOptions.mode !== store.getters['dev/getCurrentMode']) {
        store.dispatch('notification/showNotification', {
          color: 'warning',
          text: 'Não é possível selecionar um componente de outro modo de tela!',
          showIconNotification: false
        });

        return;
      }

      store.dispatch('dev/setSelectedTab', index);
      store.dispatch('dev/setSelectedStep', index);

      param !== '' && this.$emit(HANDLERS.SELECT_COMPONENT_DEV, param);
    },

    handleLoadTemplate(param) {
      if (!this.selectedPortal) {
        this.$store.dispatch('notification/showNotification', {
          color: 'error',
          text: 'Selecione um ambiente na parte superior para prosseguir!',
          showIconNotification: false
        });

        return;
      }

      this.$store.dispatch('dev/setCurrentTemplate', param);
    }
  }
};

export default devComponentMixin;
